// eslint-disable-next-line
/* eslint-disable no-restricted-syntax */
/* eslint-disable dot-notation */
import React, { useState, useEffect, useMemo, useContext, useRef } from "react";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import Chart from "react-apexcharts";
import { get } from "../Network/requests";
import { getUrl } from "../Network/urls";
import { tokenExpire } from "../Utils";
import { AgGridReact } from "ag-grid-react";
import "react-datepicker/dist/react-datepicker.css";
import "../Assets/css/datepickercustom.css";
import "../Assets/css/euRecordKeepingAnalytics.css";
import { ModuleRegistry } from "ag-grid-community";
import { ClientSideRowModelModule } from "ag-grid-community";
import { ExcelExportModule } from "ag-grid-enterprise";
import NotSubscribedMessageComponent from "./UI/NotSubscribedMessageComponent";
import Loader from "./UI/Loader";
import AppContext from "../Store/AppContext";
import CustomChart from "./UI/CustomChart";
import { CircularProgress } from "@mui/material";
import CustomDatepicker from "./UI/CustomDatepicker";
import { FormControl, Select, MenuItem } from "@mui/material";
import { Tooltip, IconButton } from "@mui/material";
import { RiFileExcel2Fill } from "react-icons/ri";
import GridRowDetailsExpand from "./UI/GridRowDetailsExpand";
import OpenInFullIcon from "@mui/icons-material/OpenInFull";
import CloseFullscreenIcon from "@mui/icons-material/CloseFullscreen";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import GridGroupIcons from "./UI/GridGroupIcons";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import ArrowLeftIcon from "@mui/icons-material/ArrowLeft";
import EmptyChart from "./UI/EmptyChart";
import LoaderWrapper from "./UI/LoaderWrapper";
import {
  RTSKPICalculation,
  BasicKPICalculation,
} from "./UI/KpiCalculationModal";
import { BsInfoLg } from "react-icons/bs";
// import { GoInfo } from "react-icons/go";
import { FaCircleInfo } from "react-icons/fa6";
import { GoInfo } from "react-icons/go";
import { FaInfoCircle } from "react-icons/fa";

ModuleRegistry.registerModules([ClientSideRowModelModule, ExcelExportModule]);

// function DashboardAnalyticsComponent({ onAnalytics }) {
function UKRecordKeepingAnalyticsComponent({
  productCode,
  regulationCode,
  dateRange,
  setDateRange,
}) {
  const {
    secretAccessId,
    secretAccessKey,
    clientDetails,
    handleEncryptOtherParamsOfAPI,
    encryptedClientValuesObj,
    inputBucketName,
    handleDecryptResponse,
    handleAPIEncryptValue,
    handleTextColorOfOutputFiles,
    handleEncryptValue,
    handleDecryptedValue,
    handleGetStoreDateRangeAndItem,
    handleSetStoreDateRangeAndItem,
  } = useContext(AppContext);
  const [loading, setLoading] = useState(true);
  const storedDateRangeData = handleGetStoreDateRangeAndItem();

  const getFormattedDate = (date) => date.toLocaleDateString("fr-CA");

  const [chartKey, setChartKey] = useState(0);
  const navigate = useNavigate();
  const [showDatePicker, setShowDatePicker] = useState(true);

  // Color mapping for all charts
  const COLOR_MAP = {
    records: {
      Valid: "#84e44c",
      Processed: "#73D13D",
      Error: "#fd5956",
      Excluded: "#60bbf4",
      Ineligible: "#FEB019",
    },

    recordType: {
      Execution: "#84e44c",
      Order: "#60bbf4",
    },

    general: [
      "#52C41A",
      "#69C0FF",
      "#E53935",
      "#FFC53D",
      "#B37FEB",
      "#73D13D",
      "#FF9C6E",
      "#95DE64",
    ],
    sourceSystem: [
      "#69C0FF",
      "#FFC53D",
      "#73D13D",
      "#B37FEB",
      "#40E0D0",
      "#FF9C6E",
      "#95DE64",
    ],
    errorTrends: ["#73D13D", "#fe6966", "#69C0FF"],
    errorCategory: {
      "Invalid format": "#f8423f",
      "Invalid value": "#f76565",
      "Blank value": "#fa9954",
      Unknown: "#6C757D",
    },

    products: ["#84e44c", "#60bbf4", "#FEB019", "#B37FEB", "#FF9C6E"],
    dailyInput: ["#60bbf4"], // "#84e44c",
    dailyOutput: {
      // "Processed Files": "#73D13D",
      "Processed Transactions": "#73D13D",
      // "Ineligible Files": "#F9A825",
      "Ineligible Transactions": "#FEB019",
      // "Error Files": "#f7504e",
      "Error Transactions": "#fe6966",
      // "Excluded Files": "#60bbf4",
      "Excluded Transactions": "#69C0FF",
    },
  };

  const getChartColors = (chartType, labels = []) => {
    const config = COLOR_MAP[chartType];
    if (!config) return [COLOR_MAP.general];

    if (Array.isArray(config)) {
      return labels.map((_, i) => config[i % config.length]);
    }

    return labels.map((label) => {
      if (config[label]) return config[label];
      const key = Object.keys(config).find(
        (k) => k.toLowerCase() === label.toLowerCase(),
      );
      return key ? config[key] : "#D9D9D9";
    });
  };

  const asNumber = (x) => (typeof x === "number" ? x : Number(x ?? 0));
  const formatXAxisLabel = (val) => {
    if (typeof val !== "string") return String(val);
    if (/^\d{4}-\d{2}-\d{2}$/.test(val)) {
      const [y, m, d] = val.split("-").map(Number);
      return new Date(y, m - 1, d).toLocaleDateString("en-US", {
        day: "2-digit",
        month: "short",
      }); // "01 Jan"
    }
    if (/^\d{4}-\d{2}$/.test(val)) return val; // prettyMonth(val);
    return val;
  };

  const gridOptions = useMemo(
    () => ({
      pagination: true,
      paginationPageSize: 25,
      paginationPageSizeSelector: false,
      suppressCellFocus: true,
    }),
    [],
  );
  const defaultColDef = useMemo(
    () => ({
      flex: 1,
      minWidth: 120,
      resizable: true,
      sortable: true,
      filter: true,
      cellStyle: { textAlign: "left" },
    }),
    [],
  );
  //  ------------- KPIS States------------
  const getRowByType = (rows, type) => rows.find((r) => r?.[0] === type) ?? [];
  // for Annex RTS 24
  const [activeKpiKey, setActiveKpiKey] = useState(null);
  // for Annex Orders and Annex Executions
  const [activeBasicKpiKey, setActiveBasicKpiKey] = useState(null);
  // for Annex RTS 24
  const openKpiModal = (key) => setActiveKpiKey(key);
  const closeKpiModal = () => setActiveKpiKey(null);
  // for Annex Orders and Annex Executions
  const openBasicKpiModal = (key) => setActiveBasicKpiKey(key);
  const closeBasicKpiModal = () => setActiveBasicKpiKey(null);

  const getValue = (row, idx) => Number(row?.[idx] ?? 0);
  const emptyKpis = {
    // Valid
    valid: 0,
    validOrds: 0,
    validExe: 0,

    // Invalid
    invalid: 0,
    invalidOrds: 0,
    invalidExe: 0,

    // Excluded
    excluded: 0,
    excludedOrds: 0,
    excludedExe: 0,

    // Totals
    totalRecs: 0,
    totalOrds: 0,
    totalExe: 0,

    // Percentages of total
    validPctOfTotal: 0,
    invalidPctOfTotal: 0,
    excludedPctOfTotal: 0,

    // Accuracy
    accuracyPct: 0,
    accuracyExePct: 0,
    accuracyOrdsPct: 0,

    // Error %
    errorPct: 0,
    errorExePct: 0,
    errorOrdsPct: 0,
  };

  const [kpiData, setKpiData] = useState(emptyKpis);

  //  -------------  Error Detail Grid  States--------------
  const timerRef = useRef("");
  const [selectedRow, setSelectedRow] = useState({});
  const [isDetailBoxOpen, setIsDetailBoxOpen] = useState(false);
  const [hoverPos, setHoverPos] = useState(null); // {x, y}
  const [showDialog, setShowDialog] = useState(false);

  const handleDoubleClick = (params) => {
    setIsDetailBoxOpen(true);
    const clickedRow = params.data;
    const isFieldIncludeUnderscore = Object.keys(clickedRow).some((field) =>
      field.includes("_"),
    );
    if (isFieldIncludeUnderscore) {
      let formattedData = {};
      params.api.getColumnDefs().forEach((col) => {
        formattedData[col.headerName] = clickedRow[col.field];
      });
      setSelectedRow(formattedData);
    } else {
      setSelectedRow(clickedRow);
    }
  };

  const [erroDetailsCols, setErrorDetailsCols] = useState([]);
  const [errorDetailsData, setErrorDetailsData] = useState([]);

  // -----------  Download Excel
  const errorDetailsRef = useRef(null);
  const handleDownloadExcel = () => {
    const now = new Date();
    const pad = (num) => String(num).padStart(2, "0");
    const fileName = `${
      downloadFileList[dropDownValue]
    }_error_details_${now.getFullYear()}${pad(now.getMonth() + 1)}${pad(
      now.getDate(),
    )}_${pad(now.getHours())}${pad(now.getMinutes())}${pad(
      now.getSeconds(),
    )}..xlsx`;

    // -------------
    errorDetailsRef?.current?.api.exportDataAsExcel({
      fileName,
    });
  };

  //  ---------  First Row ------
  //------------  Records Pie chart states for Annex Orders, RTS 24 and Annex Executions
  const [recordsLabels, setRecordsLabels] = useState([]);
  const [recordsSeries, setRecordsSeries] = useState([]);

  const recordsDonutOptions = useMemo(
    () => ({
      chart: {
        type: "donut",
        animations: {
          enabled: true,
          easing: "easeinout",
          speed: 800,
        },
        events: {
          // disable
          dataPointSelection: function (event, chartContext, config) {
            return false;
          },
        },
      },
      labels: recordsLabels,
      colors: getChartColors("records", recordsLabels),
      // No border between slices
      stroke: { width: 0 },
      legend: {
        position: "bottom",
        horizontalAlign: "center",
        fontSize: "13px",
        fontWeight: 500,
        markers: { width: 10, height: 10, radius: 2 },
        itemMargin: { horizontal: 6, vertical: 2 },
        height: 40,
        onItemClick: {
          toggleDataSeries: false,
        },
        onItemHover: {
          highlightDataSeries: true,
        },
        formatter: function (seriesName, opts) {
          const series = opts.w.globals.series;
          const value = series[opts.seriesIndex];
          return `${seriesName?.toUpperCase()}: ${formatNum(value)}`;
        },
      },
      tooltip: {
        y: {
          formatter: (v) => `${formatNum(v)}`,
        },
      },
      plotOptions: {
        pie: {
          expandOnClick: false,
          donut: {
            size: "65%",
            labels: {
              show: true,
              name: {
                show: true,
                fontSize: "14px",
                fontWeight: 600,
                offsetY: -6,
              },
              value: {
                show: true,
                fontSize: "16px",
                fontWeight: 700,
                offsetY: 2,
                formatter: function (val) {
                  return formatNum(val);
                },
              },
              total: {
                show: true,
                showAlways: true,
                label: "Total Records",
                fontSize: "11px",
                fontWeight: 600,
                color: "black",
                formatter: function (w) {
                  const total = w.globals.seriesTotals.reduce(
                    (a, b) => a + b,
                    0,
                  );
                  return formatNum(total);
                },
              },
            },
          },
        },
      },
      dataLabels: {
        enabled: true,
        offset: -8,
        style: {
          fontSize: "10px",
          fontWeight: 600,
          colors: ["#ffffff"],
        },
        formatter: (_val, opts) => {
          const series = opts.w.globals.series;
          const total = series.reduce((a, b) => a + b, 0);
          const value = series[opts.seriesIndex];
          const pct = total ? (value / total) * 100 : 0;
          return pct >= 8 ? `${pct.toFixed(1)}%` : "";
        },
      },
      responsive: [
        {
          breakpoint: 1200,
          options: {
            plotOptions: { pie: { donut: { size: "70%" } } },
            dataLabels: { offset: -6, style: { fontSize: "10px" } },
          },
        },
        {
          breakpoint: 600,
          options: {
            plotOptions: { pie: { donut: { size: "75%" } } },
            dataLabels: { offset: -4, style: { fontSize: "9px" } },
          },
        },
      ],
    }),
    [recordsLabels],
  );

  //------------------ Record Type Pie chart states for Annex Orders, RTS 24 and Annex Executions
  const [recordTypeLabels, setRecordTypeLabels] = useState([]);
  const [recordTypeSeries, setRecordTypeSeries] = useState([]);

  const recordsTypeDonutOptions = useMemo(
    () => ({
      chart: {
        type: "donut",
        animations: {
          enabled: true,
          easing: "easeinout",
          speed: 800,
        },
        events: {
          dataPointSelection: function (event, chartContext, config) {
            return false;
          },
        },
      },
      labels: recordTypeLabels,
      colors: getChartColors("recordType", recordTypeLabels),
      stroke: { width: 0 },
      legend: {
        position: "bottom",
        horizontalAlign: "center",
        fontSize: "12px",
        fontWeight: 500,
        markers: { width: 10, height: 10, radius: 2 },
        itemMargin: { horizontal: 6, vertical: 2 },
        height: 40,
        onItemClick: {
          toggleDataSeries: false,
        },
        onItemHover: {
          highlightDataSeries: true,
        },
        formatter: function (seriesName, opts) {
          const series = opts.w.globals.series;
          const value = series[opts.seriesIndex];
          return `${seriesName?.toUpperCase()}: ${formatNum(value)}`;
        },
      },
      tooltip: {
        y: {
          formatter: (v) => `${formatNum(v)}`,
        },
      },
      plotOptions: {
        pie: {
          expandOnClick: false,
          donut: {
            size: "65%",
            labels: {
              show: true,
              name: {
                show: true,
                fontSize: "14px",
                fontWeight: 600,
                offsetY: -6,
              },
              value: {
                show: true,
                fontSize: "16px",
                fontWeight: 700,
                offsetY: 2,
                formatter: function (val) {
                  return formatNum(val);
                },
              },
              total: {
                show: true,
                showAlways: true,
                label: "Total Records",
                fontSize: "11px",
                fontWeight: 600,
                color: "black",
                formatter: function (w) {
                  const total = w.globals.seriesTotals.reduce(
                    (a, b) => a + b,
                    0,
                  );
                  return formatNum(total);
                },
              },
            },
          },
        },
      },
      dataLabels: {
        enabled: true,
        offset: -8,
        style: {
          fontSize: "10px",
          fontWeight: 600,
          colors: ["#ffffff"],
        },
        formatter: (_val, opts) => {
          const series = opts.w.globals.series;
          const total = series.reduce((a, b) => a + b, 0);
          const value = series[opts.seriesIndex];
          const pct = total ? (value / total) * 100 : 0;
          return pct >= 8 ? `${pct.toFixed(1)}%` : "";
        },
      },
      responsive: [
        {
          breakpoint: 1200,
          options: {
            plotOptions: { pie: { donut: { size: "70%" } } },
            dataLabels: { offset: -6, style: { fontSize: "10px" } },
          },
        },
        {
          breakpoint: 600,
          options: {
            plotOptions: { pie: { donut: { size: "75%" } } },
            dataLabels: { offset: -4, style: { fontSize: "9px" } },
          },
        },
      ],
    }),
    [recordTypeLabels],
  );
  // --------------  Source Error Category Pie chart states for RTS 24 and Annex Executions
  const [errorCatLabels, setErrorCatLabels] = useState([]);
  const [errorCatSeries, setErrorCatSeries] = useState([]);
  const errorCatDonutOptions = useMemo(
    () => ({
      chart: { type: "donut" },
      labels: errorCatLabels,
      colors: getChartColors("errorCategory", errorCatLabels),
      stroke: { width: 0 },
      legend: {
        position: "bottom",
        horizontalAlign: "center",
        fontSize: "12px",
        fontWeight: 500,
        markers: { width: 10, height: 10, radius: 2 },
        itemMargin: { horizontal: 6, vertical: 2 },
        height: 40,
        onItemClick: {
          toggleDataSeries: false,
        },
        onItemHover: {
          highlightDataSeries: true,
        },
        formatter: function (seriesName, opts) {
          const series = opts.w.globals.series;
          const value = series[opts.seriesIndex];
          return `${seriesName?.toUpperCase()}: ${formatNum(value)}`;
        },
      },
      tooltip: { y: { formatter: (v) => `${v}` } },
      plotOptions: {
        pie: {
          expandOnClick: false,
          donut: {
            size: "65%",
            labels: {
              show: true,
              name: {
                show: true,
                fontSize: "14px",
                fontWeight: 600,
                offsetY: -6,
              },
              value: {
                show: true,
                fontSize: "16px",
                fontWeight: 700,
                offsetY: 2,
                formatter: function (val) {
                  return formatNum(val);
                },
              },
              total: {
                show: true,
                showAlways: true,
                label: "Total Records",
                fontSize: "11px",
                fontWeight: 600,
                color: "black",
                formatter: function (w) {
                  const total = w.globals.seriesTotals.reduce(
                    (a, b) => a + b,
                    0,
                  );
                  return formatNum(total);
                },
              },
            },
          },
        },
      },
      dataLabels: {
        enabled: true,
        offset: -8,
        style: {
          fontSize: "10px",
          fontWeight: 600,
          colors: ["#ffffff"],
        },
        formatter: (_val, opts) => {
          const series = opts.w.globals.series;
          const total = series.reduce((a, b) => a + b, 0);
          const value = series[opts.seriesIndex];
          const pct = total ? (value / total) * 100 : 0;
          return pct >= 8 ? `${pct.toFixed(1)}%` : "";
        },
      },
      responsive: [
        {
          breakpoint: 1200,
          options: {
            plotOptions: { pie: { donut: { size: "66%" } } },
            dataLabels: { offset: -6, style: { fontSize: "10px" } },
          },
        },
        {
          breakpoint: 600,
          options: {
            plotOptions: { pie: { donut: { size: "70%" } } },
            dataLabels: { offset: -4, style: { fontSize: "9px" } },
          },
        },
      ],
    }),
    [errorCatLabels],
  );
  // -------------  Source System Pie chart states for Annex Orders, RTS 24 and Annex Executions ------------
  const [sourceSystemLabels, setSourceSystemLabels] = useState([]);
  const [sourceSystemSeries, setSourceSystemSeries] = useState([]);
  const sourceSystemDonutOptions = useMemo(
    () => ({
      chart: { type: "donut" },
      labels: sourceSystemLabels,
      colors: COLOR_MAP.sourceSystem,
      stroke: { width: 0 },
      legend: {
        position: "bottom",
        horizontalAlign: "center",
        fontSize: "12px",
        fontWeight: 500,
        markers: { width: 10, height: 10, radius: 2 },
        itemMargin: { horizontal: 6, vertical: 2 },
        height: 40,
        onItemClick: {
          toggleDataSeries: false,
        },
        onItemHover: {
          highlightDataSeries: true,
        },
        formatter: function (seriesName, opts) {
          const series = opts.w.globals.series;
          const value = series[opts.seriesIndex];
          return `${seriesName?.toUpperCase()}: ${formatNum(value)}`;
        },
      },
      tooltip: { y: { formatter: (v) => `${formatNum(v)}` } },
      plotOptions: {
        pie: {
          expandOnClick: false,
          donut: {
            size: "65%",
            labels: {
              show: true,
              name: {
                show: true,
                fontSize: "14px",
                fontWeight: 600,
                offsetY: -6,
              },
              value: {
                show: true,
                fontSize: "16px",
                fontWeight: 700,
                offsetY: 2,
                formatter: function (val) {
                  return formatNum(val);
                },
              },
              total: {
                show: true,
                showAlways: true,
                label: "Total Records",
                fontSize: "11px",
                fontWeight: 600,
                color: "black",
                formatter: function (w) {
                  const total = w.globals.seriesTotals.reduce(
                    (a, b) => a + b,
                    0,
                  );
                  return formatNum(total);
                },
              },
            },
          },
        },
      },
      dataLabels: {
        enabled: true,
        offset: -8,
        style: {
          fontSize: "10px",
          fontWeight: 600,
        },
        formatter: (_val, opts) => {
          const series = opts.w.globals.series;
          const total = series.reduce((a, b) => a + b, 0);
          const value = series[opts.seriesIndex];
          const pct = total ? (value / total) * 100 : 0;
          return pct >= 8 ? `${pct.toFixed(1)}%` : "";
        },
      },
      responsive: [
        {
          breakpoint: 1200,
          options: {
            plotOptions: { pie: { donut: { size: "66%" } } },
            dataLabels: { offset: -6, style: { fontSize: "10px" } },
          },
        },
        {
          breakpoint: 600,
          options: {
            plotOptions: { pie: { donut: { size: "70%" } } },
            dataLabels: { offset: -4, style: { fontSize: "9px" } },
          },
        },
      ],
    }),
    [sourceSystemLabels],
  );

  //------------------ Products Pie chart states for Annex Orders, RTS 24 and Annex Executions
  const [productsLabels, setProductsLabels] = useState([]);
  const [productsSeries, setProductsSeries] = useState([]);
  const productsDonutOptions = useMemo(
    () => ({
      chart: { type: "donut" },
      labels: productsLabels,
      colors: COLOR_MAP.products,
      stroke: { width: 0 },
      legend: {
        position: "bottom",
        horizontalAlign: "center",
        fontSize: "12px",
        fontWeight: 500,
        markers: { width: 10, height: 10, radius: 2 },
        itemMargin: { horizontal: 6, vertical: 2 },
        height: 40,
        onItemClick: {
          toggleDataSeries: false,
        },
        onItemHover: {
          highlightDataSeries: true,
        },
        formatter: function (seriesName, opts) {
          const series = opts.w.globals.series;
          const value = series[opts.seriesIndex];
          return `${seriesName?.toUpperCase()}: ${formatNum(value)}`;
        },
      },
      tooltip: { y: { formatter: (v) => `${v}` } },
      plotOptions: {
        pie: {
          expandOnClick: false,
          donut: {
            size: "65%",
            labels: {
              show: true,
              name: {
                show: true,
                fontSize: "14px",
                fontWeight: 600,
                offsetY: -6,
              },
              value: {
                show: true,
                fontSize: "16px",
                fontWeight: 700,
                offsetY: 2,
                formatter: function (val) {
                  return formatNum(val);
                },
              },
              total: {
                show: true,
                showAlways: true,
                label: "Total Records",
                fontSize: "11px",
                fontWeight: 600,
                color: "black",
                formatter: function (w) {
                  const total = w.globals.seriesTotals.reduce(
                    (a, b) => a + b,
                    0,
                  );
                  return formatNum(total);
                },
              },
            },
          },
        },
      },
      dataLabels: {
        enabled: true,
        offset: -8,
        style: {
          fontSize: "10px",
          fontWeight: 600,
        },
        formatter: (_val, opts) => {
          const series = opts.w.globals.series;
          const total = series.reduce((a, b) => a + b, 0);
          const value = series[opts.seriesIndex];
          const pct = total ? (value / total) * 100 : 0;
          return pct >= 8 ? `${pct.toFixed(1)}%` : "";
        },
      },
      responsive: [
        {
          breakpoint: 1200,
          options: {
            plotOptions: { pie: { donut: { size: "66%" } } },
            dataLabels: { offset: -6, style: { fontSize: "10px" } },
          },
        },
        {
          breakpoint: 600,
          options: {
            plotOptions: { pie: { donut: { size: "70%" } } },
            dataLabels: { offset: -4, style: { fontSize: "9px" } },
          },
        },
      ],
    }),
    [productsLabels],
  );

  // ------------- First Row Trends Line Chart States for Annex Orders and Executions ---------------------

  const [trendsLineCats, setTrendsLineCats] = useState([]);
  const [trendsSeries, setTrendsSeries] = useState([]);
  // Values visible per chart
  const TRENDS_SIZE = 30;
  const [trendsStartIndx, setTrendsStartIndx] = useState(0);
  const [isTrendsExpand, setIsTrendsExpand] = useState(false);
  const visibleTrendsCats = useMemo(
    () => trendsLineCats.slice(trendsStartIndx, trendsStartIndx + TRENDS_SIZE),
    [trendsLineCats, trendsStartIndx],
  );

  const visibleTrendsSeries = useMemo(
    () =>
      trendsSeries.map((s) => ({
        ...s,
        data: s.data.slice(trendsStartIndx, trendsStartIndx + TRENDS_SIZE),
      })),
    [trendsSeries, trendsStartIndx],
  );

  const trendsLineChartOptions = useMemo(
    () => ({
      chart: {
        toolbar: {
          show: true,
          tools: {
            download: false,
            selection: false,
            zoom: false,
            zoomin: true,
            zoomout: true,
            pan: false,
            reset: true,
          },
        },
        zoom: { enabled: true },
        animations: {
          enabled: true,
          easing: "easeinout",
          speed: 800,
        },
      },
      colors: COLOR_MAP.errorTrends,
      stroke: {
        width: 3,
        curve: "monotoneCubic",
        lineCap: "round",
      },
      fill: {
        type: "gradient",
        gradient: {
          shade: "dark",
          type: "vertical",
          shadeIntensity: 0.4,
          gradientToColors: ["#c0392b", "#e67e22", "#2980b9"],
          inverseColors: false,
          opacityFrom: 0.6,
          opacityTo: 0.1,
          stops: [0, 50, 100],
        },
      },
      markers: {
        size: 0,
        hover: {
          size: 8,
          sizeOffset: 3,
        },
        strokeWidth: 2,
        strokeColors: "#fff",
        fillOpacity: 1,
      },
      xaxis: {
        categories: visibleTrendsCats,
        tickPlacement: "on",
        labels: {
          style: {
            colors: "#64748b",
            fontSize: "11px",
            fontWeight: 500,
          },
          rotate: -45,
        },
        axisBorder: {
          show: true,
          color: "#e2e8f0",
        },
        axisTicks: {
          show: true,
          color: "#e2e8f0",
        },
      },
      yaxis: {
        forceNiceScale: true,
        title: {
          text: "Error Count",
          style: {
            color: "#64748b",
            fontSize: "12px",
            fontWeight: 600,
          },
        },
        labels: {
          style: {
            colors: "#64748b",
            fontSize: "11px",
          },
          formatter: (val) => Math.round(val),
        },
      },
      legend: {
        position: "bottom",
        horizontalAlign: "center",
        floating: false,
        fontSize: "12px",
        fontWeight: 500,
        markers: { width: 10, height: 10, radius: 2 },
        itemMargin: { horizontal: 6, vertical: 2 },
      },
      tooltip: {
        shared: true,
        intersect: false,
        y: { formatter: (v) => `${v}` },
      },
      grid: {
        strokeDashArray: 3,
        borderColor: "#e2e8f0",
        row: {
          colors: ["transparent", "rgba(0,0,0,0.02)"],
          opacity: 0.5,
        },
        xaxis: {
          lines: {
            show: true,
          },
        },
        yaxis: {
          lines: {
            show: true,
          },
        },
      },
      dataLabels: {
        enabled: false,
      },
    }),
    [visibleTrendsCats],
  );

  // --------- Second Row ------

  // --------- Daily Output Transactions Line Chart States for Annex Orders, RTS 24 and Annex Executions

  // Daily Output Transactions states
  const OUTPUT_SIZE = 30;
  const [outputStartIndx, setOutputStartIndx] = useState(0);
  const [isOutputExpand, setIsOutputExpand] = useState(false);

  // Daily Input Transactions states
  const INPUT_SIZE = 15;
  const [inputStartIndx, setInputStartIndx] = useState(0);
  const [isInputExpand, setIsInputExpand] = useState(false);
  const [dailyOpTxnLineSeries, setDailyOpTxnLineSeries] = useState([]);
  const [dailyOpTxnLineCats, setDailyOpTxnLineCats] = useState([]);
  const visibleOutputCats = useMemo(
    () =>
      dailyOpTxnLineCats.slice(outputStartIndx, outputStartIndx + OUTPUT_SIZE),
    [dailyOpTxnLineCats, outputStartIndx],
  );

  const visibleOutputSeries = useMemo(
    () =>
      dailyOpTxnLineSeries.map((s) => ({
        ...s,
        data: s.data.slice(outputStartIndx, outputStartIndx + OUTPUT_SIZE),
      })),
    [dailyOpTxnLineSeries, outputStartIndx],
  );

  const dailyOpTxnOptions = useMemo(
    () => ({
      chart: {
        toolbar: {
          show: true,
          tools: {
            download: false,
            selection: false,
            zoom: false,
            zoomin: true,
            zoomout: true,
            pan: false,
            reset: true,
          },
        },
        zoom: { enabled: true },
        animations: {
          enabled: true,
          easing: "easeinout",
          speed: 800,
        },
      },
      colors: getChartColors(
        "dailyOutput",
        visibleOutputSeries.length > 0
          ? visibleOutputSeries.map((s) => s.name)
          : [],
      ),
      stroke: {
        width: 3,
        curve: "monotoneCubic",
        lineCap: "round",
      },
      fill: {
        type: "gradient",
        gradient: {
          shade: "dark",
          type: "vertical",
          shadeIntensity: 0.4,
          gradientToColors: ["#c0392b", "#e67e22", "#2980b9"],
          inverseColors: false,
          opacityFrom: 0.6,
          opacityTo: 0.1,
          stops: [0, 50, 100],
        },
      },
      markers: {
        size: 0,
        hover: {
          size: 8,
          sizeOffset: 3,
        },
        strokeWidth: 2,
        strokeColors: "#fff",
        fillOpacity: 1,
      },
      xaxis: {
        categories: visibleOutputCats,
        tickPlacement: "on",
        labels: {
          style: {
            colors: "#64748b",
            fontSize: "11px",
            fontWeight: 500,
          },
          rotate: -45,
        },
        axisBorder: {
          show: true,
          color: "#e2e8f0",
        },
        axisTicks: {
          show: true,
          color: "#e2e8f0",
        },
      },
      yaxis: {
        forceNiceScale: true,
        title: {
          text: "Transaction Count",
          style: {
            color: "#64748b",
            fontSize: "12px",
            fontWeight: 600,
          },
        },
        labels: {
          style: {
            colors: "#64748b",
            fontSize: "11px",
          },
          formatter: (val) => Math.round(val),
        },
      },
      legend: {
        position: "bottom",
        horizontalAlign: "center",
        floating: false,
        fontSize: "12px",
        fontWeight: 500,
        markers: { width: 10, height: 10, radius: 2 },
        itemMargin: { horizontal: 6, vertical: 2 },
      },
      tooltip: {
        shared: true,
        intersect: false,
        y: { formatter: (v) => `${v}` },
      },
      grid: {
        strokeDashArray: 3,
        borderColor: "#e2e8f0",
        row: {
          colors: ["transparent", "rgba(0,0,0,0.02)"],
          opacity: 0.5,
        },
        xaxis: {
          lines: {
            show: true,
          },
        },
        yaxis: {
          lines: {
            show: true,
          },
        },
      },
      // hide floating values on chart
      dataLabels: {
        enabled: false,
      },
    }),
    [visibleOutputCats],
  );

  // Daily Input Transactions Bar Chart States for Annex Orders, RTS 24 and Annex Executions
  const getColumnWidth = (count) => {
    // console.log("count :", count);

    if (count <= 5) return "40%";
    if (count <= 10) return "35%";
    if (count <= 15) return "50%";
    return "65%";
  };

  const [dailyInputTxnCats, setDailyInputTxnCats] = useState([]);
  const [dailyInputTxnSeries, setDailyInputTxnSeries] = useState([]);

  const visibleInputCats = useMemo(
    () => dailyInputTxnCats.slice(inputStartIndx, inputStartIndx + INPUT_SIZE),
    [dailyInputTxnCats, inputStartIndx],
  );

  const visibleInputSeries = useMemo(
    () =>
      dailyInputTxnSeries.map((s) => ({
        ...s,
        data: s.data.slice(inputStartIndx, inputStartIndx + INPUT_SIZE),
      })),
    [dailyInputTxnSeries, inputStartIndx],
  );
  const dailyInputTxnOptions = useMemo(() => {
    // console.log("dailyInputTxnCats", dailyInputTxnCats);
    const barCount = visibleInputCats?.length;
    // console.log("barCount :", barCount);

    return {
      chart: {
        type: "bar",
        stacked: false,
        toolbar: { show: false },
        animations: {
          enabled: true,
          easing: "easeinout",
          speed: 800,
        },
      },
      colors: COLOR_MAP.dailyInput,
      fill: { type: "solid", opacity: 1 },
      plotOptions: {
        bar: {
          columnWidth: getColumnWidth(barCount),
          borderRadius: 4,
          dataLabels: {
            position: "top",
          },
        },
      },
      dataLabels: {
        enabled: false,
      },
      legend: {
        show: true,
        showForSingleSeries: true,
        position: "bottom",
        horizontalAlign: "center",
        fontSize: "12px",
        fontWeight: 500,
        markers: { width: 10, height: 10, radius: 2 },
        itemMargin: { horizontal: 6, vertical: 2 },
      },
      xaxis: {
        categories: visibleInputCats,
        labels: {
          style: {
            fontSize: "11px",
          },
        },
      },
      yaxis: {
        title: {
          text: "Transaction Count",
          style: {
            fontSize: "12px",
            fontWeight: 600,
          },
        },
        labels: {
          formatter: (val) => Math.round(val),
        },
      },
      grid: {
        strokeDashArray: 4,
        borderColor: "#e0e0e0",
      },
      tooltip: {
        y: {
          formatter: (val) => `${val.toLocaleString()} transactions`,
        },
      },
    };
  }, [visibleInputCats]);

  // --------------------
  const [isLoading, setIsLoading] = useState(false);

  const allowedRegulations = clientDetails.dataAccess[`${productCode}`] ?? [];
  const regulationCodeDefault = allowedRegulations[0] ?? null;
  const [isProductAccessible, setIsProductAccessible] = useState(false);
  const [isRegulationAccessible, setIsRegulationAccessible] = useState(false);
  // Drop down
  const [dropDownValue, setDropDownValue] = useState(
    localStorage.getItem("EU_record_keeping_regulation") ||
      regulationCodeDefault,
  );

  const clientName = false;

  const dropDownList = {
    R001: "RTS 24",
    R002: "Annex IV - Orders",
    R003: "Annex IV - Executions",
    R004: "RTS 22",
  };
  const downloadFileList = {
    R001: "RTS24",
    R002: "Annex_IV_Orders",
    R003: "Annex_IV_Executions",
    R004: "RTS_22",
  };

  // ===== Helpers =====
  const formatNum = (num) =>
    Number(Number(num)?.toFixed(2))?.toLocaleString("en-US");
  const isAllZero = (rows = []) =>
    rows.length > 0 && rows.every((item) => Number(item[1]) === 0);

  const finalDropdownList = clientDetails?.dataAccess["P001"]?.map(
    (regulation) => {
      return { item: dropDownList[regulation], value: regulation };
    },
  );

  const handleStoreKey = (dropDownValue) => {
    let storeKey = "";
    if (dropDownValue === "R001") {
      storeKey = "date_Range_EU_Record_Keeping_RTS24";
    } else if (dropDownValue === "R002") {
      storeKey = "date_Range_EU_Record_Keeping_AnnexIV_Orders";
    } else if (dropDownValue === "R003") {
      storeKey = "date_Range_EU_Record_Keeping_AnnexIV_Executions";
    } else if (dropDownValue === "R004") {
      storeKey = "date_Range_EU_Record_Keeping_RTS22";
    }
    return storeKey;
  };

  const [startDate, endDate] = dateRange;

  // Formatted date strings for API calls and display
  const start = startDate?.toLocaleDateString("fr-CA") ?? "";
  const end = endDate ? new Date(new Date(endDate).setDate(endDate.getDate() + 1)).toLocaleDateString("fr-CA") : "";
  // Function to get stored date range from localStorage
  const getStoredDateRange = (regulation) => {
    const storeKey = handleStoreKey(regulation);
    const stored = localStorage.getItem(storeKey);
    if (stored) {
      try {
        const [start, end] = JSON.parse(stored);
        return [new Date(start), new Date(end)];
      } catch (e) {
        return null;
      }
    }
    return null;
  };

  // Initialize date range from localStorage on mount
  useEffect(() => {
    const storedRange = getStoredDateRange(dropDownValue);
    if (storedRange && !startDate && !endDate) {
      setDateRange(storedRange);
    }
  }, []);

  // a palette at least as long as your max series count
  const palette = [
    "#1f77b4", // blue
    "#ff7f0e", // orange
    "#2ca02c", // green
    "#d62728", // red
    "#9467bd", // purple
    "#8c564b", // brown
    "#e377c2", // pink
    "#7f7f7f", // gray
  ];

  const [isDateRangeValid, setIsDateRangeValid] = useState(true);

  // It will return the stored date range and dropdown item
  const checkDateDifference = (start, end) => {
    if (!start || !end) return;
    const startDate = new Date(start);
    const endDate = new Date(end);
    const diffInDays = (endDate - startDate) / (1000 * 60 * 60 * 24);
    if (diffInDays > 62) {
      setIsDateRangeValid(false);
    } else setIsDateRangeValid(true);
  };

  const handleEndDateChange = (date) => {};

  const [sourceSystemData, setSourceSystemData] = useState([]);

  // ----------- Get Dashboard data ------------
  const getDashboardAnalytics = () => {
    if (clientDetails.dataAccess[productCode] ?? false) {
      setShowDatePicker(true);
    } else {
      setShowDatePicker(false);
    }
    if (clientDetails.dataAccess) {
      if (clientDetails.dataAccess[productCode]?.includes(dropDownValue)) {
        // store dates, use it for grids
        if (startDate && endDate) {
          let storeKey = handleStoreKey(dropDownValue);
          localStorage.setItem(storeKey, JSON.stringify([startDate, endDate]));
        }

        setIsProductAccessible(true);
        setIsRegulationAccessible(true);
        const encData = handleDecryptedValue(
          localStorage.getItem("RegDataVal4").toString,
        );
        const checkArrayData = (arr) => {
          let flag = false;
          if (Object.keys(arr).length > 0) {
            flag = true;
          } else {
            flag = false;
          }
          return flag;
        };
        const chartValuesInput = (val) => {
          const month = [],
            date = [],
            inputFiles = [],
            transactions = [];
          for (let i = 0; i < val.data.length; i++) {
            month.push(val.data[i][0]);
            date.push(val.data[i][1]);
            inputFiles.push(val.data[i][2]);
            transactions.push(val.data[i][3]);
          }
          return [month, date, inputFiles, transactions];
        };

        const chartValuesOutput = (val) => {
          const month = [],
            date = [],
            processedFiles = [],
            processedTxn = [],
            ineligibleFiles = [],
            ineligibleTxn = [],
            errorFiles = [],
            errorTxn = [],
            excludedFiles = [],
            excludedTxn = [];

          for (let i = 0; i < val.data.length; i++) {
            month.push(val.data[i][0]);
            date.push(val.data[i][1]);
            processedFiles.push(val.data[i][2]);
            processedTxn.push(val.data[i][3]);
            ineligibleFiles.push(val.data[i][4]);
            ineligibleTxn.push(val.data[i][5]);
            errorFiles.push(val.data[i][6]);
            errorTxn.push(val.data[i][7]);
            excludedFiles.push(val.data[i][8]);
            excludedTxn.push(val.data[i][9]);
          }
          return [
            month,
            date,
            processedFiles,
            processedTxn,
            ineligibleFiles,
            ineligibleTxn,
            errorFiles,
            errorTxn,
            excludedFiles,
            excludedTxn,
          ];
        };

        if (productCode in clientDetails.dataAccess) {
          setIsProductAccessible(true);
          setIsRegulationAccessible(true);
          const url = getUrl("get-dashboard");
          setIsLoading(true);
          const plainPayload = {
            client_id: clientDetails.clientId,
            role: clientDetails.role,
            product: productCode,
            regulation: dropDownValue, // (this is the selected regulation)
            email_id: clientDetails.email,
            start_date: start,
            end_date: end,
          };
          const encryptedOperation = handleEncryptValue("dashboard");
          const encryptedRole = handleEncryptValue(clientDetails.role);
          const encryptedClientId = handleEncryptValue(clientDetails.clientId);
          const encryptedProductCode = handleEncryptValue(productCode);
          const encryptedvalue = handleEncryptValue(dropDownValue);
          const encryptedStartDate = handleEncryptValue(start);
          const encryptedEndDate = handleEncryptValue(end);

          const data = {
            client_id: encryptedClientId,
            role: encryptedRole,
            product: encryptedProductCode,
            regulation: encryptedvalue,
            email_id: clientDetails.email,
            start_date: encryptedStartDate,
            end_date: encryptedEndDate,
            operations: encryptedOperation,
          };

          const regdataData = handleAPIEncryptValue(JSON.stringify(data));
          get(`${url}?regdata=${regdataData}`, true)
            .then((response) => {
              const {
                data: { encryptBody, statusCode, authData },
              } = response;
              setIsLoading(false);

              switch (statusCode) {
                case 200:
                  const iv = authData;
                  const idToken = localStorage.getItem("userToken");
                  const secretKey = idToken.slice(998, 1030);
                  const body = handleDecryptResponse(
                    encryptBody.toString(),
                    secretKey.toString(),
                    iv.toString(),
                  );
                  if (
                    productCode === "P001" &&
                    checkArrayData(
                      body.transaction_per_month_input[productCode].data,
                    )
                  ) {
                    setChartKey((prev) => prev + 1);
                    // console.log("body :", body);
                    //  Records Pie Chart
                    if (body?.product_arch_data?.P001?.data?.length > 0) {
                      const rows = body?.product_arch_data?.P001?.data ?? [];
                      if (rows.length === 0 || isAllZero(rows)) {
                        // check zero values

                        setRecordsLabels([]);
                        setRecordsSeries([]);
                      } else {
                        const labels = rows.map((item) => item[0]);
                        const series = rows.map((item) => item[1]);

                        setRecordsLabels(labels);
                        setRecordsSeries(series);
                      }
                    } else {
                      setRecordsLabels([]);
                      setRecordsSeries([]);
                    }
                    // console.log("body :", body);
                    if (body?.record_type_data?.P001?.data?.length > 0) {
                      const rows = body?.record_type_data?.P001?.data ?? [];

                      if (rows.length > 0) {
                        const labels = rows.map((item) => item[0]);
                        const series = rows.map((item) => item[1]);

                        setRecordTypeLabels(labels);
                        setRecordTypeSeries(series);
                      } else {
                        setRecordTypeLabels([]);
                        setRecordTypeSeries([]);
                      }
                    } else {
                      setRecordTypeLabels([]);
                      setRecordTypeSeries([]);
                    }

                    if (body?.product_data?.P001?.data?.length > 0) {
                      const rows = body?.product_data?.P001?.data ?? [];
                      if (rows.length > 0) {
                        const labels = rows.map((item) => item[0]);
                        const series = rows.map((item) => item[1]);
                        setProductsLabels(labels);
                        setProductsSeries(series);
                      } else {
                        setProductsLabels([]);
                        setProductsSeries([]);
                      }
                    } else {
                      setProductsLabels([]);
                      setProductsSeries([]);
                    }

                    // if (body?.daily_trends_data?.P001?.data?.length > 0) {
                    //   const trendsCats = body.daily_trends_data.P001.data.map(
                    //     (item) => formatXAxisLabel(item[0])
                    //   );
                    //   const trendsData = body.daily_trends_data.P001.data[0]
                    //     .slice(1)
                    //     .map((_, idx) => ({
                    //       name: body.daily_trends_data.P001.columns[idx + 1],
                    //       data: body.daily_trends_data.P001.data.map(
                    //         (row) => row[idx + 1]
                    //       ),
                    //     }));
                    //   setTrendsLineCats(trendsCats);
                    //   setTrendsSeries(trendsData);
                    // } else {
                    //   setTrendsLineCats([]);
                    //   setTrendsSeries([]);
                    // }
                    if (body?.daily_trends_data?.P001?.data?.length > 0) {
                      const trendsCats = body.daily_trends_data.P001.data.map(
                        (item) => formatXAxisLabel(item[0]),
                      );

                      const trendsData = body.daily_trends_data.P001.data[0]
                        .slice(1)
                        .map((_, idx) => ({
                          name: body.daily_trends_data.P001.columns[idx + 1],
                          data: body.daily_trends_data.P001.data.map(
                            (row) => row[idx + 1],
                          ),
                        }));

                      setTrendsLineCats(trendsCats);
                      setTrendsSeries(trendsData);
                    } else {
                      setTrendsLineCats([]);
                      setTrendsSeries([]);
                    }

                    if (body?.source_system_data?.P001?.data?.length > 0) {
                      const rows = body?.source_system_data?.P001?.data ?? [];

                      if (rows.length > 0) {
                        const labels = rows.map((item) => item[0]);
                        const series = rows.map((item) => item[1]);
                        setSourceSystemLabels(labels);
                        setSourceSystemSeries(series);
                      } else {
                        setSourceSystemLabels([]);
                        setSourceSystemSeries([]);
                      }
                    } else {
                      setSourceSystemLabels([]);
                      setSourceSystemSeries([]);
                    }

                    if (
                      body?.transaction_per_month_input?.P001?.data?.data
                        ?.length > 0
                    ) {
                      const rowData =
                        body.transaction_per_month_input.P001.data;

                      const categories = rowData.data.map((item) => {
                        const monthShort = item[0].slice(0, 3);
                        const day = item[1];
                        return `${monthShort} ${day}`;
                      });

                      const series = [
                        {
                          name: "Transactions",
                          data: rowData.data.map((item) => item[2]),
                        },
                      ];

                      setDailyInputTxnCats(categories);
                      setDailyInputTxnSeries(series);
                    } else {
                      setDailyInputTxnCats([]);
                      setDailyInputTxnSeries([]);
                    }

                    if (
                      body?.transaction_per_month_output?.P001?.data?.data
                        ?.length > 0
                    ) {
                      const outputData =
                        body.transaction_per_month_output.P001.data;
                      const cols = outputData.columns;
                      const rows = outputData.data;

                      const categories = rows.map((item) => {
                        // console.log(item[0]);
                        const monthShort = item[0].slice(0, 3);
                        return `${monthShort} ${item[1]}`;
                      });

                      // console.log("categories :", categories);

                      const series = cols.slice(2).map((col, idx) => ({
                        name: col.replace(/_/g, " "),
                        data: rows.map((row) => Number(row[idx + 2] ?? 0)),
                      }));

                      setDailyOpTxnLineCats(categories);
                      setDailyOpTxnLineSeries(series);
                    } else {
                      setDailyOpTxnLineCats([]);
                      setDailyOpTxnLineSeries([]);
                    }

                    if (body?.error_data?.P001?.data?.length > 0) {
                      const rows = body?.error_data?.P001?.data ?? [];

                      if (rows.length > 0) {
                        const errorCatLabels = rows.map((item) => item[0]);
                        const errorCatSeries = rows.map((item) => item[1]);

                        setErrorCatLabels(errorCatLabels);
                        setErrorCatSeries(errorCatSeries);
                      } else {
                        setErrorCatLabels([]);
                        setErrorCatSeries([]);
                      }
                    } else {
                      setErrorCatLabels([]);
                      setErrorCatSeries([]);
                    }

                    const kpiSource = body?.regdata_kpi_data?.P001;

                    const rows = kpiSource?.data ?? [];
                    const columns = kpiSource?.columns ?? [];

                    if (!rows.length || !columns.length) {
                      setKpiData(emptyKpis);
                      return;
                    }

                    const validIdx = columns.indexOf("Valid Record");
                    const invalidIdx = columns.indexOf("Invalid Record");
                    const excludedIdx = columns.indexOf("Excluded Records");

                    const orderRow = getRowByType(rows, "Order");
                    const executionRow = getRowByType(rows, "Execution");

                    const validOrds = getValue(orderRow, validIdx);
                    const invalidOrds = getValue(orderRow, invalidIdx);
                    const excludedOrds = getValue(orderRow, excludedIdx);

                    const validExe = getValue(executionRow, validIdx);
                    const invalidExe = getValue(executionRow, invalidIdx);
                    const excludedExe = getValue(executionRow, excludedIdx);

                    // Totals
                    const valid = validOrds + validExe;
                    const invalid = invalidOrds + invalidExe;
                    const excluded = excludedOrds + excludedExe;

                    // Total Records KPI
                    const totalOrds = validOrds + invalidOrds + excludedOrds;
                    const totalExe = validExe + invalidExe + excludedExe;
                    const totalRecs = valid + invalid + excluded;

                    const processable = valid + invalid; // (validOrds+ validExe) + (invalidOrds + invalidExe)

                    const validPctOfTotal = totalRecs
                      ? (valid / totalRecs) * 100
                      : 0;

                    const invalidPctOfTotal = totalRecs
                      ? (invalid / totalRecs) * 100
                      : 0;

                    const excludedPctOfTotal = totalRecs
                      ? (excluded / totalRecs) * 100
                      : 0;

                    //  Accuracy % KPI
                    const accuracyPct = processable
                      ? (valid / processable) * 100 // valid = validOrds + validExe
                      : 0;

                    const accuracyOrdsPct = processable
                      ? (validOrds / totalOrds) * 100 // totalOrds =  validOrds + invalidOrds + excludedOrds
                      : 0;

                    const accuracyExePct = processable
                      ? (validExe / totalExe) * 100 // totalExe = validExe + invalidExe + excludedExe
                      : 0;
                    // ---------- Error % --------
                    // processable = valid + invalid
                    const errorPct = processable
                      ? (invalid / processable) * 100
                      : 0;
                    // -----
                    const errorOrdsPct = processable
                      ? (invalidOrds / totalOrds) * 100
                      : 0;
                    // -----
                    const errorExePct = processable
                      ? (invalidExe / totalExe) * 100
                      : 0;

                    setKpiData({
                      valid,
                      validOrds,
                      validExe,

                      invalid,
                      invalidOrds,
                      invalidExe,

                      excluded,
                      excludedOrds,
                      excludedExe,

                      totalRecs,
                      totalOrds,
                      totalExe,

                      validPctOfTotal,
                      invalidPctOfTotal,
                      excludedPctOfTotal,

                      accuracyPct,
                      accuracyExePct,
                      accuracyOrdsPct,

                      errorPct,
                      errorExePct,
                      errorOrdsPct,
                    });
                  }

                  // ------------ Error details Grid--------
                  const errorDetailsCols =
                    body?.error_details_data?.[productCode]?.columns ?? [];
                  const errorDetailsRows =
                    body?.error_details_data?.[productCode]?.data ?? [];

                  if (errorDetailsCols.length > 0) {
                    const modifiedCols = errorDetailsCols.map((col) => ({
                      headerName: col,
                      field: col.toLowerCase().replace(/ /g, "_"),
                    }));
                    setErrorDetailsCols(modifiedCols);

                    const errorData = errorDetailsRows.map((row) => {
                      const rowObj = {};
                      errorDetailsCols.forEach((col, i) => {
                        const field = col.toLowerCase().replace(/ /g, "_");
                        rowObj[field] =
                          field === "error_percentage" ? row[i] + "%" : row[i];
                      });
                      return rowObj;
                    });
                    setErrorDetailsData(errorData);
                    setLoading(false);
                  }
                  break;
                case 400:
                  setLoading(false);
                  toast.error("Error fetching the analytics.");
                  break;
                default:
                  toast.error(process.env.REACT_APP_DEFAULT_ERROR_MESSAGE);
              }
            })
            .catch((error) => {
              console.error(error);
              setIsLoading(false);
              console.log("error ", error);
              toast.error("Your session has expired. Please log in again.");
              // toast.error(process.env.REACT_APP_DEFAULT_ERROR_MESSAGE);
              tokenExpire(error.response, navigate);
            });
        } else {
          setIsProductAccessible(false);
          setIsLoading(false);
        }
      } else {
        setIsRegulationAccessible(false);
        setIsLoading(false);
      }
    }
  };

  const handleSubmit = () => {
    if (isDateRangeValid) {
      getDashboardAnalytics();
    } else toast.error("Date Range should not be more than 2 months");
  };
  const loadedTabsRef = useRef(new Set([]));
  useEffect(() => {
    if (startDate && endDate) {
      // On initial mount and whenever codes change, fetch with current dates
      getDashboardAnalytics();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [regulationCode, productCode, startDate, endDate, dropDownValue]);

  const onCellMouseOver = (params) => {
    if (timerRef.current) clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => {
      const e = params.event;
      setHoverPos({ x: e.clientX, y: e.clientY });
      setShowDialog(true);
    }, 200);
  };

  const onCellMouseOut = () => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
      timerRef.current = null;
    }
    setShowDialog(false);
  };

  // -------- KPI Wrapper ----------
  const KpiValue = ({ children, className = "text-start" }) => {
    if (isLoading) {
      return (
        <div className={className}>
          <CircularProgress className={className} size={16} />
        </div>
      );
    }
    return <>{children}</>;
  };

  useEffect(() => {
    setTrendsStartIndx(0);
  }, [trendsLineCats.length]);

  useEffect(() => {
    setOutputStartIndx(0);
  }, [dailyOpTxnLineCats.length]);

  useEffect(() => {
    setInputStartIndx(0);
  }, [dailyInputTxnCats.length]);

  const handlePrev = () => {
    setTrendsStartIndx((prev) => Math.max(prev - TRENDS_SIZE, 0));
  };

  const handleNext = () => {
    setTrendsStartIndx((prev) =>
      Math.min(prev + TRENDS_SIZE, trendsLineCats.length - TRENDS_SIZE),
    );
  };

  const handleOutputPrev = () => {
    setOutputStartIndx((prev) => Math.max(prev - OUTPUT_SIZE, 0));
  };

  const handleOutputNext = () => {
    setOutputStartIndx((prev) =>
      Math.min(prev + OUTPUT_SIZE, dailyOpTxnLineCats.length - OUTPUT_SIZE),
    );
  };

  const handleInputPrev = () => {
    setInputStartIndx((prev) => Math.max(prev - INPUT_SIZE, 0));
  };

  const handleInputNext = () => {
    setInputStartIndx((prev) =>
      Math.min(prev + INPUT_SIZE, dailyInputTxnCats.length - INPUT_SIZE),
    );
  };

  return (
    <>
      {/* {isLoading && <Loader />} */}
      <main className="middle_section dashboard_middle">
        <div className="container">
          <div className="rx_table_wrapper table-responsive padding-fix overflow-hidden">
            <div>
              {/* ================= COMMON HEADER ================= */}

              {showDatePicker && (
                <div
                  className="dashboard_header"
                  style={{
                    width: "100%",
                    justifyContent: "start",
                    alignItems: "end",
                    background: "white",
                    padding: "15px 15px",
                    borderRadius: "12px",
                    marginBottom: "0",
                  }}
                >
                  <div
                    className="d-flex align-items-center headerContainer pb-0 gap-3"
                    style={{ margin: "0px 3px", width: "100%" }}
                  >
                    <div className="col-auto px-0">
                      <CustomDatepicker
                        startDate={startDate}
                        endDate={endDate}
                        onChange={setDateRange}
                        showWrapperStyles={false}
                      />
                    </div>

                    <FormControl
                      sx={{
                        m: 1,
                        minWidth: 180,
                        width: "fit-content",
                        margin: 0,
                      }}
                      size="small"
                    >
                      <Select
                        value={dropDownValue}
                        onChange={(e) => {
                          setDropDownValue(e.target.value);

                          // const storeKey = localStorage.getItem(
                          //   handleStoreKey(e.target.value)
                          // );

                          // if (storeKey) {
                          //   const [storedStart, storedEnd] =
                          //     JSON.parse(storeKey);
                          //   setDateRange([
                          //     new Date(storedStart),
                          //     new Date(storedEnd),
                          //   ]);
                          //   localStorage.setItem(
                          //     storeKey,
                          //     JSON.stringify([storedStart, storedEnd])
                          //   );
                          // }
                          // If it is not required please remove it later
                          localStorage.setItem(
                            "EU_record_keeping_regulation",
                            e.target.value,
                          );

                          handleSetStoreDateRangeAndItem(
                            startDate,
                            endDate,
                            e.target.value,
                          );
                        }}
                        MenuProps={{ disableScrollLock: true }}
                        sx={{
                          fontSize: 14,
                          height: 37,
                          width: 194,
                          borderRadius: "8px",
                          "& .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#ccc",
                            borderRadius: "8px",
                          },
                        }}
                      >
                        {finalDropdownList?.map((option) => (
                          <MenuItem key={option.value} value={option.value}>
                            {option.item}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                    <div
                      className="ms-auto"
                      style={{ width: "fix-content", marginLeft: "auto" }}
                    >
                      <GridGroupIcons
                        refreshIcon
                        fullScreenIcon={false}
                        onRefresh={getDashboardAnalytics}
                        iconsDisabled={isLoading}
                        downloadIcon={false}
                        // onDownloadCSV={() => {}} // Download analytics
                        // borderRadius={10}
                      />
                    </div>
                    {/* <button
                      className="generate-analytics"
                      type="button"
                      onClick={() => {
                        if (startDate && endDate) handleSubmit();
                        else toast.error("Please select valid date");
                      }}
                    >
                      Generate Analytics
                    </button> */}
                  </div>
                </div>
              )}
              {isProductAccessible && isRegulationAccessible ? (
                <>
                  {dropDownValue === "R005" ? (
                    <>
                      {/* ===== KPIs ===== */}
                      <div className="kpis">{/* KPIs code unchanged */}</div>

                      {isProductAccessible && isRegulationAccessible ? (
                        <>{/* Charts code unchanged */}</>
                      ) : (
                        <NotSubscribedMessageComponent />
                      )}
                    </>
                  ) : dropDownValue === "R002" || dropDownValue === "R003" ? ( //  Annex IV - Orders
                    <>
                      <div className="dashboard-grid">
                        {/* KPIS  */}
                        <>
                          <div className="kpis">
                            {/* TOTAL */}
                            <div className="kpi violet">
                              <div
                                style={{
                                  display: "grid",
                                  gap: "10px",
                                  alignItems: "flex-start",
                                  gridTemplateColumns: "40% auto",
                                }}
                              >
                                <div>
                                  <div className="kpi-title">Total Records</div>
                                  <div className="kpi-value">
                                    <KpiValue>
                                      {formatNum(kpiData.totalRecs)}
                                    </KpiValue>
                                  </div>
                                </div>
                              </div>
                              <div className="d-flex align-items-center">
                                <div className="kpi-foot">
                                  in current view
                                  <span
                                    onClick={() =>
                                      openBasicKpiModal("totalRecords")
                                    }
                                  >
                                    <FaInfoCircle className="kpi-info-icon" />
                                  </span>
                                </div>
                              </div>
                            </div>

                            {/* VALID */}
                            <div className="kpi green">
                              <div
                                style={{
                                  display: "grid",
                                  gap: "10px",
                                  alignItems: "flex-start",
                                  gridTemplateColumns: "50% auto",
                                }}
                              >
                                <div>
                                  <div className="kpi-title">
                                    Processed Records
                                  </div>
                                  <div className="kpi-value">
                                    <KpiValue>
                                      {formatNum(kpiData.valid)}
                                    </KpiValue>
                                  </div>
                                </div>
                              </div>

                              <div className="kpi-foot">
                                {kpiData.validPctOfTotal.toFixed(2)}% of total
                                <span
                                  onClick={() =>
                                    openBasicKpiModal("processedRecords")
                                  }
                                >
                                  <FaInfoCircle className="kpi-info-icon" />
                                </span>
                              </div>
                            </div>

                            {/* INVALID */}
                            <div className="kpi red">
                              <div
                                style={{
                                  display: "grid",
                                  gap: "10px",
                                  alignItems: "flex-start",
                                  gridTemplateColumns: "50% auto",
                                }}
                              >
                                <div>
                                  <div className="kpi-title">Exceptions</div>
                                  <div className="kpi-value">
                                    <KpiValue>
                                      {formatNum(kpiData.invalid)}
                                    </KpiValue>
                                  </div>
                                </div>
                              </div>

                              <div className="kpi-foot">
                                {kpiData.invalidPctOfTotal.toFixed(2)}% of total
                                <span
                                  onClick={() =>
                                    openBasicKpiModal("exceptionsRecords")
                                  }
                                >
                                  <FaInfoCircle className="kpi-info-icon" />
                                </span>
                              </div>
                            </div>

                            {/* EXCLUDED */}
                            <div className="kpi amber">
                              <div
                                style={{
                                  display: "grid",
                                  gap: "10px",
                                  alignItems: "flex-start",
                                  gridTemplateColumns: "50% auto",
                                }}
                              >
                                <div>
                                  <div className="kpi-title">
                                    Excluded Records
                                  </div>
                                  <div className="kpi-value">
                                    <KpiValue>
                                      {formatNum(kpiData.excluded)}
                                    </KpiValue>
                                  </div>
                                </div>
                              </div>

                              <div className="kpi-foot">
                                {kpiData.excludedPctOfTotal.toFixed(2)}% of
                                total
                                <span
                                  onClick={() =>
                                    openBasicKpiModal("excludedRecords")
                                  }
                                >
                                  <FaInfoCircle className="kpi-info-icon" />
                                </span>
                              </div>
                            </div>

                            {/* ACCURACY */}
                            <div className="kpi green">
                              <div
                                style={{
                                  display: "grid",
                                  gap: "10px",
                                  alignItems: "flex-start",
                                  gridTemplateColumns: "50% auto",
                                }}
                              >
                                <div>
                                  <div className="kpi-title">Accuracy %</div>
                                  <div className="kpi-value">
                                    <KpiValue>
                                      {kpiData.accuracyPct?.toFixed(2)}%
                                    </KpiValue>
                                  </div>
                                </div>
                              </div>
                              <div className="kpi-foot">
                                <span
                                  onClick={() =>
                                    openBasicKpiModal("accuracyPercentage")
                                  }
                                >
                                  <FaInfoCircle className="kpi-info-icon" />
                                </span>
                              </div>
                            </div>

                            {/* ERROR */}
                            <div className="kpi red">
                              <div
                                style={{
                                  display: "grid",
                                  gap: "10px",
                                  alignItems: "flex-start",
                                  gridTemplateColumns: "50% auto",
                                }}
                              >
                                <div>
                                  <div className="kpi-title">Error %</div>
                                  <div className="kpi-value">
                                    <KpiValue>
                                      {kpiData.errorPct.toFixed(2)}%
                                    </KpiValue>
                                  </div>
                                </div>
                              </div>
                              <div className="kpi-foot">
                                <span
                                  onClick={() =>
                                    openBasicKpiModal("errorPercentage")
                                  }
                                >
                                  <FaInfoCircle className="kpi-info-icon" />
                                </span>
                              </div>
                            </div>
                          </div>

                          <div className="row2">
                            {/* ROW 1 */}
                            {/* Records Pie Chart */}
                            <div className="pie card">
                              <div className="card-title">Records</div>
                              <div className="chart-container">
                                <LoaderWrapper isLoading={isLoading}>
                                  {recordsSeries?.length ? ( //recordsSeries?.length > 0
                                    <Chart
                                      options={recordsDonutOptions}
                                      series={recordsSeries}
                                      type="donut"
                                      height={340}
                                    />
                                  ) : (
                                    <EmptyChart type="donut" />
                                  )}
                                </LoaderWrapper>
                              </div>
                              {/* <div className="chip">Counts by records</div> */}
                              {clientName && (
                                <div className="chip client-chip">
                                  {clientName}
                                </div>
                              )}
                            </div>
                            {/* Product Pie Chart */}
                            <div className="pie card">
                              <div className="card-title">Products</div>
                              <div className="chart-container">
                                <LoaderWrapper isLoading={isLoading}>
                                  {productsSeries?.length ? (
                                    <Chart
                                      options={productsDonutOptions}
                                      series={productsSeries}
                                      type="donut"
                                      height={340}
                                      width="100%"
                                    />
                                  ) : (
                                    <EmptyChart type="donut" />
                                  )}
                                </LoaderWrapper>
                              </div>
                              {/* <div className="chip">Counts by products</div> */}
                              {clientName && (
                                <div className="chip client-chip">
                                  {clientName}
                                </div>
                              )}
                            </div>
                            {/* Trends Line chart */}
                            {/* <div className="line card">
                            {" "}
                            <div className="card-title">Error Trends</div>{" "}
                            <div
                              style={{ position: "relative", minHeight: 240 }}
                            >
                              {" "}
                              <ChartLoadingOverlay
                                show={isLoading}
                                minHeight={240}
                              /> 
                              <Chart
                                options={trendsLineChartOptions}
                                series={trendsSeries}
                                type="area"
                                height={Math.max(
                                  320,
                                  trendsLineCats.length * 4
                                )}
                              />
                            </div> 
                          </div> */}
                            <div
                              className={`line card ${
                                isTrendsExpand ? "expanded" : ""
                              }`}
                            >
                              {/* Header */}
                              <div className="error-trends-header">
                                <div className="error-trends-title-section">
                                  <div className="error-trends-title">
                                    Error Trends
                                  </div>
                                </div>
                                <div className="d-flex align-items-center gap-2">
                                  {/* Date Range with Navigation */}
                                  <div className="error-trends-navigation">
                                    <IconButton
                                      size="large"
                                      onClick={handlePrev}
                                      disabled={trendsStartIndx === 0}
                                      className={`error-trends-nav-button ${
                                        trendsStartIndx === 0
                                          ? "disabled"
                                          : "enabled"
                                      }`}
                                    >
                                      <ArrowLeftIcon fontSize="large" />
                                    </IconButton>

                                    <span className="error-trends-date-range">
                                      {visibleTrendsCats.length > 0
                                        ? `${visibleTrendsCats[0]} – ${
                                            visibleTrendsCats[
                                              visibleTrendsCats.length - 1
                                            ]
                                          }`
                                        : "No data"}
                                    </span>

                                    <IconButton
                                      size="large"
                                      onClick={handleNext}
                                      disabled={
                                        trendsStartIndx + TRENDS_SIZE >=
                                        trendsLineCats.length
                                      }
                                      className={`error-trends-nav-button ${
                                        trendsStartIndx + TRENDS_SIZE >=
                                        trendsLineCats.length
                                          ? "disabled"
                                          : "enabled"
                                      }`}
                                    >
                                      <ArrowRightIcon fontSize="large" />
                                    </IconButton>
                                  </div>
                                  {/* Expand Button */}
                                  <IconButton
                                    size="small"
                                    onClick={() => setIsTrendsExpand((v) => !v)}
                                    aria-label="Expand chart"
                                    className="error-trends-expand-button"
                                  >
                                    {isTrendsExpand ? (
                                      <CloseFullscreenIcon fontSize="small" />
                                    ) : (
                                      <OpenInFullIcon fontSize="small" />
                                    )}
                                  </IconButton>
                                </div>
                              </div>

                              {/* Chart */}
                              <div className="chart-container">
                                <LoaderWrapper isLoading={isLoading}>
                                  {visibleTrendsSeries?.length > 0 ? (
                                    <Chart
                                      options={trendsLineChartOptions}
                                      series={visibleTrendsSeries}
                                      type="area"
                                      height={isTrendsExpand ? "90%" : "100%"}
                                    />
                                  ) : (
                                    <EmptyChart type="area" />
                                  )}
                                </LoaderWrapper>
                              </div>
                            </div>
                          </div>
                          <div className="row3">
                            {/* Row 2 */}
                            {/* Daily Input Transactions Bar Chart */}
                            <div
                              className={`bar card ${
                                isInputExpand ? "expanded" : ""
                              }`}
                            >
                              {/* Header */}
                              <div className="error-trends-header">
                                <div className="error-trends-title-section">
                                  <div className="error-trends-title">
                                    Daily Input Transactions
                                  </div>
                                </div>
                                <div className="d-flex align-items-center gap-2">
                                  {/* Date Range with Navigation */}
                                  <div className="error-trends-navigation">
                                    <IconButton
                                      size="large"
                                      onClick={handleInputPrev}
                                      disabled={inputStartIndx === 0}
                                      className={`error-trends-nav-button ${
                                        inputStartIndx === 0
                                          ? "disabled"
                                          : "enabled"
                                      }`}
                                    >
                                      <ArrowLeftIcon fontSize="large" />
                                    </IconButton>

                                    <span className="error-trends-date-range">
                                      {visibleInputCats.length > 0
                                        ? `${visibleInputCats[0]} – ${
                                            visibleInputCats[
                                              visibleInputCats.length - 1
                                            ]
                                          }`
                                        : "No data"}
                                    </span>

                                    <IconButton
                                      size="large"
                                      onClick={handleInputNext}
                                      disabled={
                                        inputStartIndx + INPUT_SIZE >=
                                        dailyInputTxnCats.length
                                      }
                                      className={`error-trends-nav-button ${
                                        inputStartIndx + INPUT_SIZE >=
                                        dailyInputTxnCats.length
                                          ? "disabled"
                                          : "enabled"
                                      }`}
                                    >
                                      <ArrowRightIcon fontSize="large" />
                                    </IconButton>
                                  </div>
                                  {/* Expand Button */}
                                  <IconButton
                                    size="small"
                                    onClick={() => setIsInputExpand((v) => !v)}
                                    aria-label="Expand chart"
                                    className="error-trends-expand-button"
                                  >
                                    {isInputExpand ? (
                                      <CloseFullscreenIcon fontSize="small" />
                                    ) : (
                                      <OpenInFullIcon fontSize="small" />
                                    )}
                                  </IconButton>
                                </div>
                              </div>

                              {/* Chart */}
                              <div className="chart-container">
                                <LoaderWrapper isLoading={isLoading}>
                                  {visibleInputSeries?.length ? (
                                    <Chart
                                      options={dailyInputTxnOptions}
                                      series={visibleInputSeries}
                                      type="bar"
                                      height={isInputExpand ? 520 : 340}
                                      // height={isTrendsExpand ? "90%" : "100%"}
                                      width="100%"
                                    />
                                  ) : (
                                    <EmptyChart type="bar" />
                                  )}
                                </LoaderWrapper>
                              </div>
                            </div>
                            {/*Orders and Executions Daily Output Transactions Line Chart */}
                            <div
                              className={`line card ${
                                isOutputExpand ? "expanded" : ""
                              }`}
                            >
                              {/* Header */}
                              <div className="error-trends-header">
                                <div className="error-trends-title-section">
                                  <div className="error-trends-title">
                                    Daily Output Transactions
                                  </div>
                                </div>
                                <div className="d-flex align-items-center gap-2">
                                  {/* Date Range with Navigation */}
                                  <div className="error-trends-navigation">
                                    <IconButton
                                      size="large"
                                      onClick={handleOutputPrev}
                                      disabled={outputStartIndx === 0}
                                      className={`error-trends-nav-button ${
                                        outputStartIndx === 0
                                          ? "disabled"
                                          : "enabled"
                                      }`}
                                    >
                                      <ArrowLeftIcon fontSize="large" />
                                    </IconButton>

                                    <span className="error-trends-date-range">
                                      {visibleOutputCats.length > 0
                                        ? `${visibleOutputCats[0]} – ${
                                            visibleOutputCats[
                                              visibleOutputCats.length - 1
                                            ]
                                          }`
                                        : "No data"}
                                    </span>

                                    <IconButton
                                      size="large"
                                      onClick={handleOutputNext}
                                      disabled={
                                        outputStartIndx + OUTPUT_SIZE >=
                                        dailyOpTxnLineCats.length
                                      }
                                      className={`error-trends-nav-button ${
                                        outputStartIndx + OUTPUT_SIZE >=
                                        dailyOpTxnLineCats.length
                                          ? "disabled"
                                          : "enabled"
                                      }`}
                                    >
                                      <ArrowRightIcon fontSize="large" />
                                    </IconButton>
                                  </div>
                                  {/* Expand Button */}
                                  <IconButton
                                    size="small"
                                    onClick={() => setIsOutputExpand((v) => !v)}
                                    aria-label="Expand chart"
                                    className="error-trends-expand-button"
                                  >
                                    {isOutputExpand ? (
                                      <CloseFullscreenIcon fontSize="small" />
                                    ) : (
                                      <OpenInFullIcon fontSize="small" />
                                    )}
                                  </IconButton>
                                </div>
                              </div>

                              {/* Chart */}
                              <div className="chart-container">
                                <LoaderWrapper isLoading={isLoading}>
                                  {visibleOutputSeries?.length > 0 ? (
                                    <Chart
                                      options={dailyOpTxnOptions}
                                      series={visibleOutputSeries}
                                      type="area"
                                      // height={isOutputExpand ? 520 : 340}
                                      height={isOutputExpand ? "90%" : "100%"}
                                      width="100%"
                                    />
                                  ) : (
                                    <EmptyChart type="area" />
                                  )}
                                </LoaderWrapper>
                              </div>
                            </div>
                            {/* Source System Pie Chart */}
                            <div className="pie card">
                              <div className="card-title">Source System</div>
                              <div className="chart-container">
                                <LoaderWrapper isLoading={isLoading}>
                                  {sourceSystemSeries?.length ? (
                                    <Chart
                                      options={sourceSystemDonutOptions}
                                      series={sourceSystemSeries}
                                      type="donut"
                                      height={340}
                                    />
                                  ) : (
                                    <EmptyChart type="donut" />
                                  )}
                                </LoaderWrapper>
                              </div>
                              {/* <div className="chip">Counts by source system</div>
                            {clientName && (
                              <div className="chip client-chip">
                                {clientName}
                              </div>
                            )} */}
                            </div>
                          </div>
                          {/* Error Details Grid */}
                          <div className="d-flex flex-column gap-3">
                            {/* AG Grid #2 */}
                            <div className="grid-card red-grid-theme">
                              <div
                                className="ag-theme-quartz grid-host d-flex flex-column"
                                style={{ height: "500px", width: "100%" }}
                              >
                                <div className="grid-header">
                                  <div className="d-flex align-items-center position-relative">
                                    <div
                                      className="section-title m-0 flex-grow-1 text-center"
                                      style={{ textAlign: "center" }}
                                    >
                                      Exceptions Accumulative Report
                                    </div>

                                    <div
                                      className="download-excel d-flex align-items-center position-absolute"
                                      style={{ right: 0 }}
                                      onClick={handleDownloadExcel}
                                    >
                                      <Tooltip
                                        title="Download all records"
                                        arrow
                                      >
                                        <IconButton
                                          sx={{
                                            color: "#16325C",
                                            gap: 1,
                                            padding: 0,
                                          }}
                                        >
                                          <RiFileExcel2Fill size={16} />
                                        </IconButton>
                                      </Tooltip>

                                      <span>Download Excel</span>
                                    </div>
                                  </div>
                                </div>
                                <div style={{ flex: "1 1 auto" }}>
                                  <LoaderWrapper isLoading={isLoading}>
                                    <AgGridReact
                                      theme="legacy"
                                      ref={errorDetailsRef}
                                      rowData={errorDetailsData}
                                      columnDefs={erroDetailsCols}
                                      defaultColDef={defaultColDef}
                                      gridOptions={gridOptions}
                                      onCellMouseOver={onCellMouseOver}
                                      onCellMouseOut={onCellMouseOut}
                                      onRowDoubleClicked={handleDoubleClick}
                                      enableCellTextSelection
                                      animateRows
                                    />
                                  </LoaderWrapper>
                                </div>
                              </div>
                            </div>
                          </div>
                        </>
                      </div>
                    </>
                  ) : (
                    // RTS 24
                    <>
                      <div className="dashboard-grid">
                        {/* Row 1 */}
                        <div className="kpis">
                          {/* TOTAL */}
                          <div className="kpi violet">
                            <div
                              style={{
                                display: "grid",
                                gap: "10px",
                                alignItems: "flex-start",
                                gridTemplateColumns: "50% auto",
                              }}
                            >
                              <div>
                                <div className="kpi-title">Total Records</div>
                                <div className="kpi-value">
                                  <KpiValue>
                                    {formatNum(kpiData.totalRecs)}
                                  </KpiValue>
                                </div>
                              </div>

                              <KpiValue className="text-center">
                                <div className="kpi-breakdown kpi-breakdown-total">
                                  <div className="breakdown-item">
                                    <span className="breakdown-label">
                                      Orders:
                                    </span>
                                    <span className="breakdown-value">
                                      {formatNum(kpiData.totalOrds)}
                                    </span>
                                  </div>
                                  <div className="breakdown-item">
                                    <span className="breakdown-label">
                                      Executions:
                                    </span>
                                    <span className="breakdown-value">
                                      {formatNum(kpiData.totalExe)}
                                    </span>
                                  </div>
                                </div>
                              </KpiValue>
                            </div>
                            <div className="kpi-foot">
                              in current view
                              <span
                                onClick={() => openKpiModal("totalRecords")}
                              >
                                <FaInfoCircle className="kpi-info-icon" />
                              </span>
                            </div>
                          </div>

                          {/* VALID */}
                          <div className="kpi green">
                            <div
                              style={{
                                display: "grid",
                                gap: "10px",
                                alignItems: "flex-start",
                                gridTemplateColumns: "50% auto",
                              }}
                            >
                              <div>
                                <div className="kpi-title">
                                  Processed Records
                                </div>
                                <div className="kpi-value">
                                  <KpiValue>
                                    {formatNum(kpiData.valid)}
                                  </KpiValue>
                                </div>
                              </div>

                              <KpiValue className="text-center">
                                <div className="kpi-breakdown kpi-breakdown-valid">
                                  <div className="breakdown-item">
                                    <span className="breakdown-label">
                                      Orders:
                                    </span>
                                    <span className="breakdown-value">
                                      {formatNum(kpiData.validOrds)}
                                    </span>
                                  </div>
                                  <div className="breakdown-item">
                                    <span className="breakdown-label">
                                      Executions:
                                    </span>
                                    <span className="breakdown-value">
                                      {formatNum(kpiData.validExe)}
                                    </span>
                                  </div>
                                </div>
                              </KpiValue>
                            </div>

                            <div className="kpi-foot">
                              {kpiData.validPctOfTotal.toFixed(2)}% of total
                              <span
                                onClick={() => openKpiModal("processedRecords")}
                              >
                                <FaInfoCircle className="kpi-info-icon" />
                              </span>
                            </div>
                          </div>

                          {/* INVALID */}
                          <div className="kpi red">
                            <div
                              style={{
                                display: "grid",
                                gap: "10px",
                                alignItems: "flex-start",
                                gridTemplateColumns: "50% auto",
                              }}
                            >
                              <div>
                                <div className="kpi-title">Exceptions</div>
                                <div className="kpi-value">
                                  <KpiValue>
                                    {formatNum(kpiData.invalid)}
                                  </KpiValue>
                                </div>
                              </div>

                              <KpiValue className="text-center">
                                <div className="kpi-breakdown kpi-breakdown-invalid">
                                  <div className="breakdown-item">
                                    <span className="breakdown-label">
                                      Orders:
                                    </span>
                                    <span className="breakdown-value">
                                      {formatNum(kpiData.invalidOrds)}
                                    </span>
                                  </div>

                                  <div className="breakdown-item">
                                    <span className="breakdown-label">
                                      Executions:
                                    </span>
                                    <span className="breakdown-value">
                                      {formatNum(kpiData.invalidExe)}
                                    </span>
                                  </div>
                                </div>
                              </KpiValue>
                            </div>

                            <div className="kpi-foot">
                              {kpiData.invalidPctOfTotal.toFixed(2)}% of total
                              <span
                                onClick={() =>
                                  openKpiModal("exceptionsRecords")
                                }
                              >
                                <FaInfoCircle className="kpi-info-icon" />
                              </span>
                            </div>
                          </div>

                          {/* EXCLUDED */}
                          <div className="kpi amber">
                            <div
                              style={{
                                display: "grid",
                                gap: "10px",
                                alignItems: "flex-start",
                                gridTemplateColumns: "50% auto",
                              }}
                            >
                              <div>
                                <div className="kpi-title">
                                  Excluded Records
                                </div>
                                <div className="kpi-value">
                                  <KpiValue>
                                    {formatNum(kpiData.excluded)}
                                  </KpiValue>
                                </div>
                              </div>

                              <KpiValue className="text-center">
                                <div className="kpi-breakdown kpi-breakdown-excluded">
                                  <div className="breakdown-item">
                                    <span className="breakdown-label">
                                      Orders:
                                    </span>
                                    <span className="breakdown-value">
                                      {formatNum(kpiData.excludedOrds)}
                                    </span>
                                  </div>
                                  <div className="breakdown-item">
                                    <span className="breakdown-label">
                                      Executions:
                                    </span>
                                    <span className="breakdown-value">
                                      {formatNum(kpiData.excludedExe)}
                                    </span>
                                  </div>
                                </div>
                              </KpiValue>
                            </div>

                            <div className="kpi-foot">
                              {kpiData.excludedPctOfTotal.toFixed(2)}% of total
                              <span
                                onClick={() => openKpiModal("excludedRecords")}
                              >
                                <FaInfoCircle className="kpi-info-icon" />
                              </span>
                            </div>
                          </div>

                          {/* ACCURACY */}
                          <div className="kpi green">
                            <div
                              style={{
                                display: "grid",
                                gap: "10px",
                                alignItems: "flex-start",
                                gridTemplateColumns: "50% auto",
                              }}
                            >
                              <div>
                                <div className="kpi-title">Accuracy %</div>
                                <div className="kpi-value">
                                  <KpiValue>
                                    {kpiData.accuracyPct.toFixed(2)}%
                                  </KpiValue>
                                </div>
                              </div>

                              <KpiValue className="text-center">
                                <div className="kpi-breakdown kpi-breakdown-accuracy">
                                  <div className="breakdown-item">
                                    <span className="breakdown-label">
                                      Orders:
                                    </span>
                                    <span className="breakdown-value">
                                      {formatNum(kpiData.accuracyOrdsPct)} %
                                    </span>
                                  </div>

                                  <div className="breakdown-item">
                                    <span className="breakdown-label">
                                      Executions:
                                    </span>
                                    <span className="breakdown-value">
                                      {formatNum(kpiData.accuracyExePct)} %
                                    </span>
                                  </div>
                                </div>
                              </KpiValue>
                            </div>
                            <div className="kpi-foot">
                              <span
                                onClick={() =>
                                  openKpiModal("accuracyPercentage")
                                }
                              >
                                <FaInfoCircle className="kpi-info-icon" />
                              </span>
                            </div>
                          </div>

                          {/* ERROR */}
                          <div className="kpi red">
                            <div
                              style={{
                                display: "grid",
                                gap: "10px",
                                alignItems: "flex-start",
                                gridTemplateColumns: "50% auto",
                              }}
                            >
                              <div>
                                <div className="kpi-title">Error %</div>
                                <div className="kpi-value">
                                  <KpiValue>
                                    {kpiData.errorPct.toFixed(2)}%
                                  </KpiValue>
                                </div>
                              </div>

                              <KpiValue className="text-center">
                                <div className="kpi-breakdown kpi-breakdown-error">
                                  <div className="breakdown-item">
                                    <span className="breakdown-label">
                                      Orders:
                                    </span>
                                    <span className="breakdown-value">
                                      {formatNum(kpiData.errorOrdsPct)} %
                                    </span>
                                  </div>

                                  <div className="breakdown-item">
                                    <span className="breakdown-label">
                                      Executions:
                                    </span>
                                    <span className="breakdown-value">
                                      {formatNum(kpiData.errorExePct)} %
                                    </span>
                                  </div>
                                </div>
                              </KpiValue>
                            </div>
                            <div className="kpi-foot">
                              <span
                                onClick={() => openKpiModal("errorPercentage")}
                              >
                                <FaInfoCircle className="kpi-info-icon" />
                              </span>
                            </div>
                          </div>
                        </div>

                        <div className="row2">
                          {/*RTS 24 Records Pie Chart  */}
                          <div className="pie card">
                            <div className="card-title">Records</div>
                            <div className="chart-container">
                              <LoaderWrapper isLoading={isLoading}>
                                {recordsSeries?.length ? (
                                  <Chart
                                    options={recordsDonutOptions}
                                    series={recordsSeries}
                                    type="donut"
                                    height={340}
                                  />
                                ) : (
                                  <EmptyChart type="donut" />
                                )}
                              </LoaderWrapper>
                            </div>
                            {/* <div className="chip">Counts by records</div> */}
                          </div>
                          {/* Record Type Pie Chart  */}
                          <div className="pie card">
                            <div className="card-title">Record Type</div>
                            <div className="chart-container">
                              <LoaderWrapper isLoading={isLoading}>
                                {recordTypeSeries?.length ? (
                                  <Chart
                                    options={recordsTypeDonutOptions}
                                    series={recordTypeSeries}
                                    type="donut"
                                    height={340}
                                  />
                                ) : (
                                  <EmptyChart type="donut" />
                                )}
                              </LoaderWrapper>
                            </div>
                            {/* <div className="chip">Counts by error type</div> */}
                            {clientName && (
                              <div className="chip client-chip">
                                {clientName}
                              </div>
                            )}
                          </div>
                          {/* Source System Pie Chart */}
                          <div className="pie card">
                            <div className="card-title">Source System</div>
                            <div className="chart-container">
                              <LoaderWrapper isLoading={isLoading}>
                                {sourceSystemSeries?.length ? (
                                  <Chart
                                    options={sourceSystemDonutOptions}
                                    series={sourceSystemSeries}
                                    type="donut"
                                    height={340}
                                  />
                                ) : (
                                  <EmptyChart type="donut" />
                                )}
                              </LoaderWrapper>
                            </div>
                            {/* <div className="chip">Counts by error type</div> */}
                            {clientName && (
                              <div className="chip client-chip">
                                {clientName}
                              </div>
                            )}
                          </div>
                          {/* Product Pie Chart */}
                          <div className="pie card">
                            <div className="card-title">Product</div>
                            <div className="chart-container">
                              <LoaderWrapper isLoading={isLoading}>
                                {productsSeries?.length ? (
                                  <Chart
                                    options={productsDonutOptions}
                                    series={productsSeries}
                                    type="donut"
                                    height={340}
                                    width="100%"
                                  />
                                ) : (
                                  <EmptyChart type="donut" />
                                )}
                              </LoaderWrapper>
                            </div>
                            {/* <div className="chip">Counts by error type</div> */}
                            {clientName && (
                              <div className="chip client-chip">
                                {clientName}
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="row3">
                          {/* ROW 1 */}
                          {/* Daily Input Transactions Bar Chart */}
                          <div
                            className={`bar card ${
                              isInputExpand ? "expanded" : ""
                            }`}
                          >
                            {/* Header */}
                            <div className="error-trends-header">
                              <div className="error-trends-title-section">
                                <div className="error-trends-title">
                                  Daily Input Records
                                </div>
                              </div>
                              <div className="d-flex align-items-center gap-2">
                                {/* Date Range with Navigation */}
                                <div className="error-trends-navigation">
                                  <IconButton
                                    size="large"
                                    onClick={handleInputPrev}
                                    disabled={inputStartIndx === 0}
                                    className={`error-trends-nav-button ${
                                      inputStartIndx === 0
                                        ? "disabled"
                                        : "enabled"
                                    }`}
                                  >
                                    <ArrowLeftIcon fontSize="large" />
                                  </IconButton>

                                  <span className="error-trends-date-range">
                                    {visibleInputCats.length > 0
                                      ? `${visibleInputCats[0]} – ${
                                          visibleInputCats[
                                            visibleInputCats.length - 1
                                          ]
                                        }`
                                      : "No data"}
                                  </span>

                                  <IconButton
                                    size="large"
                                    onClick={handleInputNext}
                                    disabled={
                                      inputStartIndx + INPUT_SIZE >=
                                      dailyInputTxnCats.length
                                    }
                                    className={`error-trends-nav-button ${
                                      inputStartIndx + INPUT_SIZE >=
                                      dailyInputTxnCats.length
                                        ? "disabled"
                                        : "enabled"
                                    }`}
                                  >
                                    <ArrowRightIcon fontSize="large" />
                                  </IconButton>
                                </div>
                                {/* Expand Button */}
                                <IconButton
                                  size="small"
                                  onClick={() => setIsInputExpand((v) => !v)}
                                  aria-label="Expand chart"
                                  className="error-trends-expand-button"
                                >
                                  {isInputExpand ? (
                                    <CloseFullscreenIcon fontSize="small" />
                                  ) : (
                                    <OpenInFullIcon fontSize="small" />
                                  )}
                                </IconButton>
                              </div>
                            </div>

                            {/* Chart */}
                            <div className="chart-container">
                              <LoaderWrapper isLoading={isLoading}>
                                {visibleInputSeries?.length ? (
                                  <Chart
                                    options={dailyInputTxnOptions}
                                    series={visibleInputSeries}
                                    type="bar"
                                    // height={isInputExpand ? 520 : 340}
                                    height={isInputExpand ? "100%" : "90%"}
                                    width="100%"
                                  />
                                ) : (
                                  <EmptyChart type="bar" />
                                )}
                              </LoaderWrapper>
                            </div>
                            {clientName && (
                              <div className="chip client-chip">
                                {clientName}
                              </div>
                            )}
                          </div>
                          {/* RTS 24 Daily Output Transactions Line Chart */}
                          <div
                            className={`line card ${
                              isOutputExpand ? "expanded" : ""
                            }`}
                          >
                            {/* Header */}
                            <div className="error-trends-header">
                              <div className="error-trends-title-section">
                                <div className="error-trends-title">
                                  Daily Output Records
                                </div>
                              </div>
                              <div className="d-flex align-items-center gap-2">
                                {/* Date Range with Navigation */}
                                <div className="error-trends-navigation">
                                  <IconButton
                                    size="large"
                                    onClick={handleOutputPrev}
                                    disabled={outputStartIndx === 0}
                                    className={`error-trends-nav-button ${
                                      outputStartIndx === 0
                                        ? "disabled"
                                        : "enabled"
                                    }`}
                                  >
                                    <ArrowLeftIcon fontSize="large" />
                                  </IconButton>

                                  <span className="error-trends-date-range">
                                    {visibleOutputCats.length > 0
                                      ? `${visibleOutputCats[0]} – ${
                                          visibleOutputCats[
                                            visibleOutputCats.length - 1
                                          ]
                                        }`
                                      : "No data"}
                                  </span>

                                  <IconButton
                                    size="large"
                                    onClick={handleOutputNext}
                                    disabled={
                                      outputStartIndx + OUTPUT_SIZE >=
                                      dailyOpTxnLineCats.length
                                    }
                                    className={`error-trends-nav-button ${
                                      outputStartIndx + OUTPUT_SIZE >=
                                      dailyOpTxnLineCats.length
                                        ? "disabled"
                                        : "enabled"
                                    }`}
                                  >
                                    <ArrowRightIcon fontSize="large" />
                                  </IconButton>
                                </div>
                                {/* Expand Button */}
                                <IconButton
                                  size="small"
                                  onClick={() => setIsOutputExpand((v) => !v)}
                                  aria-label="Expand chart"
                                  className="error-trends-expand-button"
                                >
                                  {isOutputExpand ? (
                                    <CloseFullscreenIcon fontSize="small" />
                                  ) : (
                                    <OpenInFullIcon fontSize="small" />
                                  )}
                                </IconButton>
                              </div>
                            </div>

                            {/* Chart */}
                            <div className="chart-container">
                              <LoaderWrapper isLoading={isLoading}>
                                {visibleOutputSeries?.length > 0 ? (
                                  <Chart
                                    options={dailyOpTxnOptions}
                                    series={visibleOutputSeries}
                                    type="area"
                                    height={isOutputExpand ? 520 : 340}
                                  />
                                ) : (
                                  <EmptyChart type="area" />
                                )}
                              </LoaderWrapper>
                            </div>
                            {clientName && (
                              <div className="chip client-chip">
                                {clientName}
                              </div>
                            )}
                          </div>
                          {/* Error Category Pie Chart */}
                          <div className="pie card">
                            <div className="card-title">Error Category</div>
                            <div className="chart-container">
                              <LoaderWrapper isLoading={isLoading}>
                                {errorCatSeries?.length ? (
                                  <Chart
                                    options={errorCatDonutOptions}
                                    series={errorCatSeries}
                                    type="donut"
                                    height={340}
                                  />
                                ) : (
                                  <EmptyChart type="donut" />
                                )}
                              </LoaderWrapper>
                            </div>
                            {/* <div className="chip">Counts by error type</div> */}
                            {clientName && (
                              <div className="chip client-chip">
                                {clientName}
                              </div>
                            )}
                          </div>
                        </div>
                        {/* Error Details Grid */}
                        <div className="d-flex flex-column gap-3">
                          {/* AG Grid #2 */}
                          <div className="grid-card red-grid-theme">
                            <div
                              className="ag-theme-quartz grid-host d-flex flex-column"
                              style={{ height: "500px", width: "100%" }}
                            >
                              <div className="grid-header">
                                <div className="d-flex align-items-center position-relative">
                                  <div
                                    className="section-title m-0 flex-grow-1 text-center"
                                    style={{ textAlign: "center" }}
                                  >
                                    Exceptions Accumulative Report
                                  </div>

                                  <div
                                    className="download-excel d-flex align-items-center position-absolute"
                                    style={{ right: 0 }}
                                    onClick={handleDownloadExcel}
                                  >
                                    <Tooltip title="Download all records" arrow>
                                      <IconButton
                                        sx={{
                                          color: "#16325C",
                                          gap: 1,
                                          padding: 0,
                                        }}
                                      >
                                        <RiFileExcel2Fill size={16} />
                                      </IconButton>
                                    </Tooltip>

                                    <span
                                      className="ps-2"
                                      style={{ fontSize: "15px" }}
                                    >
                                      Download Excel
                                    </span>
                                  </div>
                                </div>
                              </div>
                              <div style={{ flex: "1 1 auto" }}>
                                {/* <LoaderWrapper isLoading={isLoading}> */}
                                <AgGridReact
                                  theme="legacy"
                                  ref={errorDetailsRef}
                                  rowData={errorDetailsData}
                                  columnDefs={erroDetailsCols}
                                  defaultColDef={defaultColDef}
                                  gridOptions={gridOptions}
                                  onCellMouseOver={onCellMouseOver}
                                  onCellMouseOut={onCellMouseOut}
                                  onRowDoubleClicked={handleDoubleClick}
                                  enableCellTextSelection
                                  animateRows
                                />
                                {/* </LoaderWrapper> */}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                </>
              ) : (
                <NotSubscribedMessageComponent />
              )}
            </div>
          </div>
        </div>
      </main>

      <GridRowDetailsExpand
        showDialog={showDialog}
        selectedRow={selectedRow}
        hoverPos={hoverPos}
        isErrGrid
        isDetailBoxOpen={isDetailBoxOpen}
        setIsDetailBoxOpen={setIsDetailBoxOpen}
      />
      {/* RTS 24 */}
      <RTSKPICalculation
        kpiKey={activeKpiKey}
        kpiData={kpiData}
        onClose={closeKpiModal}
      />
      {/* Annex Orders & Annex Executions */}
      <BasicKPICalculation
        kpiKey={activeBasicKpiKey}
        regulationCode={dropDownValue}
        kpiData={kpiData}
        onClose={closeBasicKpiModal}
      />
    </>
  );
}

export default UKRecordKeepingAnalyticsComponent;
//// KPI Calculation ////////
